import { LeftOutlineIcon } from '@carboncopyco/icons';
import { GreenMagnifyingGlassIllustration } from '@carboncopyco/illustrations';
import { Button, EmptyView, TextBase } from '@carboncopyco/ui';

export const WorkspacePageEmptySearch = ({
  resetControls,
}: {
  resetControls: () => void;
}) => {
  return (
    <EmptyView
      illustration={
        <GreenMagnifyingGlassIllustration
          height={80}
          width={80}
        />
      }
      title="Filters on?"
      message={
        <div className="flex flex-col items-center gap-5 ">
          <TextBase label="Nothing matches your current search" />
          <Button
            link
            label="Clear all"
            leftIcon={<LeftOutlineIcon />}
            onClick={() => {
              resetControls();
            }}
          />
        </div>
      }
    />
  );
};
